import { useState } from "react";
import PropTypes from "prop-types";
import { withGenericConfig } from "/contexts/generic-config-context";
import { componentStyles } from "./template-long-description.scss";

const TemplateLongDescription = ({ descriptions, translate }) => {
  const [readMore, setReadMore] = useState(false);

  if (!descriptions || descriptions.length === 0) return null;

  const firstParagraph = descriptions[0];
  const restParagraphs = descriptions.slice(1);

  const handleReadMoreClick = () => {
    setReadMore(true);
  };

  return (
    <div className="template-long-description">
      <div className="template-description-main-title">{translate("templateCenter.longDescription.title")}</div>
      <div className="template-paragraph-wrapper">{firstParagraph?.paragraphContent}</div>
      {!readMore && (
        <span className="template-description-read-more" onClick={handleReadMoreClick}>
          {translate("templateCenter.longDescription.readMore")}
        </span>
      )}
      {readMore &&
        restParagraphs.length > 0 &&
        restParagraphs.map((description, index) => (
          <div className="template-paragraph-wrapper">
            <div key={`description_${index}`}>{description.paragraphContent}</div>
          </div>
        ))}
      <style jsx>{componentStyles}</style>
    </div>
  );
};

TemplateLongDescription.propTypes = {
  descriptions: PropTypes.arrayOf(
    PropTypes.shape({
      paragraphContent: PropTypes.string
    })
  )
};

TemplateLongDescription.defaultProps = {
  descriptions: []
};

export default withGenericConfig(TemplateLongDescription);
